import React from "react";
import { Route, Routes } from "react-router-dom";
import { StripeConnectList } from "./containers/StripeConnectList";

export const StripeConnect = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<StripeConnectList />} />
      </Routes>
    </>
  );
};
